import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=73c160b4&scoped=true&"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=73c160b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c160b4",
  null
  
)

export default component.exports